<template>
    <div v-show="isShow">
        <div class="confirm-dialog-box">
            <div class="text">{{ text }}</div>
            <div class="confirm">
                <div class="cancel" @click="show">{{ $route.path.includes('/pay') ? '等会再看' : '取消' }}</div>
                <div class="button" @click="handleDelete">
                    <span v-show="!isLoading">{{ $route.path.includes('/pay') ? '查看订单' : '确定' }}</span>
                    <van-loading color="#ea6f7b" size="24px" v-show="isLoading"/>
                </div>
            </div>
        </div>
        <div class="shadow" @click="show"></div>
    </div>
</template>

<script>
export default {
  name: 'Confirm',
  components: {
  },
  data(){
      return {
          isShow: false,
          isLoading: false,
          text:'确定删除这篇文章吗?',
          type:'',
      }
  },
  destroyed(){
    document.querySelector('body').style.overflow = '' // 恢复滚动
  },
  methods:{
        showLoading(){
            this.isLoading = !this.isLoading
        },
        show(type){
            this.isShow = !this.isShow
            if(this.isShow){
                document.querySelector('body').style.overflow = 'hidden' // 阻止弹窗背景滚动
            } else {
                document.querySelector('body').style.overflow = '' // 恢复滚动
            }
            if(type){
                this.type = type
            }
            if(this.type === 'comment'){
                this.text = '删除这条评论吗?'
            } else if(type === 'reply'){
                this.text = '删除这条回复吗?'
            } else if(type === 'adderss'){
                this.text = '删除这条地址吗?'
            } else if(type === 'pay'){
                this.text = '您的订单已生成, 请前往查看订单'
            } else if(type === 'deleteOrder'){
                this.text = '删除这个订单吗?'
            } else if(type === 'cancelOrder'){
                this.text = '您的订单未支付, 确认取消订单吗?'
            } else if(type === 'cancelOrderPaid'){
                this.text = '您的订单已支付, 确认取消订单吗?'
            } else if(type === 'cancelOrderMonthlyPay'){
                this.text = '确认取消该月结订单吗?'
            } else if(type === 'clearCart'){
                this.text = '确认清空采购车吗?'
            } else if(type === 'agreement'){
                this.text = '请先阅读并同意《用户协议》和《隐私政策》'
            } else {
                this.text = '删除这篇文章吗?'
            }
        },
        handleDelete(){
            if(this.$route.path.includes('/pay')){
                this.$emit('goOrderPage')
            } else if(this.type === 'cancelOrder' || this.type === 'cancelOrderPaid' || this.type === 'cancelOrderMonthlyPay'){
                this.$emit('cancelOrder', this.type)
            } else {
                this.$emit('handleDelete', this.type)
            }
        },
  },
  props:{

  }
}
</script>

<style scoped lang="scss">
.shadow {
    position: fixed;
    z-index: 1001;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.3);
}
.confirm-dialog-box {
    width: 80%;
    max-width: 625px;
    line-height: 50px;
    margin: 0 auto;
    color: #000;
    background: #FFF;
    max-width: 625px;
    margin: 0 auto;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 20px;
    position: fixed;
    border-radius: 5px;
    top: 35%;
    z-index: 1002;
    .text {
        font-size: 16px;
        padding: 20px 0;
        border-bottom: 1px solid #cdcdcd;
    }
    .confirm {
        display: flex;
        .button {
            width: 50%;
            font-size: 18px;
            color: #eb411f;
        }
        .cancel {
            width: 50%;
            font-size: 18px;
            color: #000;
            border-right: 1px solid #cdcdcd;
        }
    }
}
.van-loading {
    position: relative !important;
    left: 0;
    right: 0;
    top: 2px;
    transform: none;
    -webkit-transform: none;
    -ms-transform: none;
    font-size: 0;
    vertical-align: middle;
    -ms-transform: none;
}
</style>
